<ng-container *ngIf="gameGroupItem">
  <div
    class="fgbcl-game-card"
    [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }"
  >
    <div class="game-group-image-block">
      <img class="game-group-item-image" alt="{{ gameGroupItem.Title }}" src="{{ gameGroupItem.Image | contentImage: '1' }}" />

      <!--Completed Text-->
      <ng-container
        *ngIf="
          (gameGroupItem.Status == gamePlayStatus.Completed && groupType !== groupTypes.Predictor) ||
          (gameGroupItem.Status == gamePlayStatus.Completed &&
            gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).value == 'completed')
        "
      >
        <div class="image-overlay"></div>

        <div class="game-group-completed-predictor">
          <div class="game-predictor-you-score-point-section">
            <div class="game-predictor-you-score-point-text">
              {{ 'fgbcl.game.item.completed.card.scored.text' | translate }}
            </div>
            <div class="game-predictor-you-score-point-value">
              {{ gameGroupItem.CorrectQuestions || 0 }}/{{ gameGroupItem.TotalQuestions || 0 }}
            </div>
          </div>
          <div class="game-predictor-you-score-point-section-vertical-divider"></div>
          <div class="game-predictor-you-score-point-section">
            <div class="game-predictor-you-score-point-text">
              {{ 'fgbcl.game.item.completed.card.point.text' | translate }}
            </div>
            <div class="game-predictor-you-score-point-value">{{ gameGroupItem.PointsAwarded || 0 }}</div>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          (gameGroupItem.Sponsor &&
            gameGroupItem.Sponsor.SponsorId &&
            groupType == groupTypes.Trivia &&
            gameGroupItem.Status != gamePlayStatus.Completed) ||
          (gameGroupItem.Sponsor &&
            gameGroupItem.Sponsor.SponsorId &&
            gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).value != 'completed' &&
            groupType == groupTypes.Predictor)
        "
      >
        <a
          [attr.href]="gameGroupItem.Sponsor.SponsorLink || null"
          [attr.target]="gameGroupItem.Sponsor.SponsorLink ? '_blank' : null"
        >
          <img
            class="game-group-sponsor-image"
            src="{{ gameGroupItem.Sponsor.SponsorImage | contentImage: '1' }}"
            alt="{{ gameGroupItem.Title }}"
          />
        </a>
      </ng-container>
    </div>

    <div class="game-group-name-section">
      <div>
        <div class="game-featured-text-block">
          <div
            *ngIf="
              gameGroupItem.Featured &&
              !gameGroupItem.ComingSoon &&
              !gameGroupItem.Locked &&
              gameGroupItem.Status != gamePlayStatus.Completed
            "
            class="game-icon-text-block game-featured-text"
          >
            <div class="icon material-icons mb-1">star</div>
            <p class="game-featured-label">{{ 'fgbcl.game.item.featured.text' | translate }}</p>
          </div>

          <!--count down for predictor-->
          <div
            *ngIf="
              groupType == groupTypes.Predictor &&
              gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).value != 'completed' &&
              gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).value != 'processing'
            "
            class="game-predictor-timer"
          >
            <fgbcl-countdown-v2
              [endDateTime]="gameGroupItem.EndDate"
              completeText="' '"
              (complete)="gameEnded($event, gameGroupItem.GroupId)"
            ></fgbcl-countdown-v2>
          </div>
          <!--count down for predictor end-->
        </div>
        <p class="games-group-title">{{ gameGroupItem.Title }}</p>
      </div>

      <!--Coming Soon start-->
      <div *ngIf="!gameGroupItem.Locked && gameGroupItem.ComingSoon" class="game-icon-text-block game-coming-soon-text-section">
        <p class="game-coming-soon-label">
          <span> {{ 'fgbcl.game.item.coming.soon.text' | translate }}</span>
          <fgbcl-countdown-v2
            [completeText]="' '"
            (complete)="comingSoonEnd($event, gameGroupItem.GroupId)"
            [startDateTime]="gameGroupItem.RequestTime"
            [endDateTime]="gameGroupItem.StartDate"
          ></fgbcl-countdown-v2>
        </p>
      </div>
      <!--Coming Soon End-->

      <!--bottom button for trivia-->
      <ng-container *ngIf="!gameGroupItem.ComingSoon && groupType == groupTypes.Trivia">
        <div *ngIf="gameGroupItem.Locked; else triviaButton" class="game-icon-text-block game-locked-text">
          <div class="icon material-icons ms-0">lock</div>
          <p class="game-locked-label">{{ 'fgbcl.game.item.locked.text' | translate }}</p>
        </div>
        <ng-template #triviaButton>
          <button
            (click)="openModal()"
            class="game-button"
            [ngClass]="{
              'game-play-button': gameGroupItem.Status === gamePlayStatus.NotStarted,
              'game-resume-button': gameGroupItem.Status === gamePlayStatus.InProgress,
              'game-view-button': gameGroupItem.Status === gamePlayStatus.Completed,
            }"
          >
            <div *ngIf="gameGroupItem.Status === gamePlayStatus.NotStarted" class="icon material-icons">play_arrow</div>
            {{ getStatusLabel(gameGroupItem.Status) | translate }}
          </button>
        </ng-template>
      </ng-container>

      <!--bottom button for Predictor-->

      <ng-container *ngIf="!gameGroupItem.ComingSoon && groupType == groupTypes.Predictor">
        <div *ngIf="gameGroupItem.Locked; else predictorButton" class="game-icon-text-block game-locked-text">
          <div class="icon material-icons ms-0">lock</div>
          <p class="game-locked-label">{{ 'fgbcl.game.item.locked.text' | translate }}</p>
        </div>
        <ng-template #predictorButton>
          <button
            [disabled]="gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).value == 'processing'"
            (click)="openModal()"
            class="game-button"
            [ngClass]="gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).class"
          >
            {{ gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).label | translate }}
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #content let-modal>
  <fgbcl-games-list-modal
    [predictorStatus]="groupType == groupTypes.Predictor ? gamesGroupQuery.getPredictorFinalStatus(gameGroupItem).value : ''"
    [gameGroup]="gameGroupItem"
    [groupType]="groupType"
    (closeModal)="closeModal()"
  ></fgbcl-games-list-modal>
</ng-template>
